export var Color;
(function (Color) {
    Color["PRIMARY"] = "#5238db";
    Color["PRIMARY_LIGHT"] = "rgba(216, 195, 240, 0.25)";
    Color["LINK"] = "#6d54f5";
    Color["SUCCESS"] = "#7be495";
    Color["GRASS_GREEN"] = "rgba(0, 130, 9, 1)";
    Color["GRASS_GREEN_LIGHT"] = "rgba(0, 130, 9, 0.05)";
    Color["WARNING"] = "#ffc336";
    Color["ERROR"] = "#fe676e";
    Color["ERROR_LIGHT"] = "rgba(254, 103, 110, 0.05)";
    Color["HEADING"] = "#030d25";
    Color["TEXT"] = "#515358";
    Color["TEXT_SECONDARY"] = "#989898";
    Color["DISABLED"] = "#d2d2d2";
    Color["BORDER_BASE"] = "#ededed";
    Color["BACKGROUND_GRAY"] = "#f0f2f5";
    Color["WHITE"] = "#fff";
})(Color || (Color = {}));
//# sourceMappingURL=color.js.map